/*
 * File: inde.xts
 * File Created: 2024-01-12 08:42:30
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-01-12 08:57:43
 * Modified By: Val Liu
 * -----
 */

export * from "./prop-innate-sync";
